import React from 'react'

import SignUpByEmail from './SignUpByEmail'
import { containerCls } from './classes'


import { useState } from 'react';
import { tw } from 'tagged-classnames-free';
export interface ISignUpFormProps {
  className?: string
  children?: React.ReactNode
  onSignUpSuccess?: () => void
  handleClickLogIn?: () => void
  titleAs?: React.ElementType
  formContainerClassName?: string
  warperClassName?: string
  readOnlyEmail?: string
}

const SignUpForm: React.FC<ISignUpFormProps> = (props) => {
  const {
    className,
    children,
    onSignUpSuccess,
    handleClickLogIn,
    titleAs,
    formContainerClassName,
    readOnlyEmail,
    // warperClassName,
  } = props

  // const router = useRouter()

  const [signUpByEmail, setSignUpByEmail] = useState(() => {
    return true
    // return !!(router.query.token && router.query.email) || !!readOnlyEmail
  })

  const onChangeSignUpByEmail = (value: boolean) => {
    setSignUpByEmail(value)
  }

  const renderContent = ({
    renderClassName,
    content,
  }: {
    renderClassName?: string
    content: React.ReactNode
  }) => {
    return (
      <div
        className={tw`
          ${containerCls}
          ${className}
          ${renderClassName}
        `}
      >
        {content}

        {children}
      </div>
    )
  }

  return (
    <>
      {renderContent({
        renderClassName: !signUpByEmail ? 'hidden' : '',
        content: (
          <SignUpByEmail
            // 表单报错文案不会在国际化切换时同步，通过 key 处理
            // key={locale}
            titleAs={titleAs}
            handleClickLogIn={handleClickLogIn}
            formContainerClassName={formContainerClassName}
            onSignUpSuccess={onSignUpSuccess}
            readOnlyEmail={readOnlyEmail}
            onChangeSignUpByEmail={onChangeSignUpByEmail}
          />
        ),
      })}
    </>
  )
}

export default SignUpForm
